import { c as _c } from "react/compiler-runtime";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/radix/dropdown-menu";
import { RelationshipToggle } from "@/components/relationship-toggle";
import { useAuth } from "@/hooks/use-auth";
import { LayoutDashboard, LogOut, Plus, Settings, User } from "lucide-react";
import Link from "next/link";
import { DropdownProps } from "./types";
export function SignInDropdown(t0) {
  const $ = _c(32);
  const {
    trigger,
    className
  } = t0;
  const {
    user,
    logout
  } = useAuth();
  const firstGroup = Array.isArray(user?.groups) ? user.groups[0] : undefined;
  const currentRelationship = user?.relation || firstGroup?.relationship || "buyer";
  let t1;
  if ($[0] !== logout) {
    t1 = async () => {
      await logout();
    };
    $[0] = logout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLogout = t1;
  if (!user) {
    return null;
  }
  let t2;
  if ($[2] !== trigger) {
    t2 = <DropdownMenuTrigger asChild={true}>{trigger}</DropdownMenuTrigger>;
    $[2] = trigger;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `unfocusable w-64 bg-white border border-gray-200 shadow-lg z-[9999] ${className || ""}`;
  const t4 = user?.name || "Unknown User";
  let t5;
  if ($[4] !== t4) {
    t5 = <div className="font-medium text-gray-900">{t4}</div>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = user?.phones?.[0]?.number || "No phone";
  let t7;
  if ($[6] !== t6) {
    t7 = <div className="text-gray-500 truncate">{t6}</div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <div className="px-3 py-2 text-sm">{t5}{t7}</div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DropdownMenuSeparator />;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="px-3 py-2"><div className="text-xs font-medium text-gray-500 mb-2">Relationship</div><RelationshipToggle /></div>;
    t11 = <DropdownMenuSeparator />;
    $[12] = t10;
    $[13] = t11;
  } else {
    t10 = $[12];
    t11 = $[13];
  }
  let t12;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <DropdownMenuItem asChild={true}><Link href="/profile" className="flex items-center"><User className="w-4 h-4 mr-2" />Profile</Link></DropdownMenuItem>;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <DropdownMenuItem asChild={true}><Link href="/dashboard" className="flex items-center"><LayoutDashboard className="w-4 h-4 mr-2" />Dashboard</Link></DropdownMenuItem>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <DropdownMenuItem asChild={true}><Link href="/sell" className="flex items-center"><Plus className="w-4 h-4 mr-2" />Add a property to sell</Link></DropdownMenuItem>;
    t15 = <DropdownMenuSeparator />;
    $[16] = t14;
    $[17] = t15;
  } else {
    t14 = $[16];
    t15 = $[17];
  }
  let t16;
  if ($[18] !== currentRelationship) {
    t16 = currentRelationship === "buyer" && <DropdownMenuItem asChild={true}><Link href="/preference-summary" className="flex items-center"><Settings className="w-4 h-4 mr-2" />Preferences</Link></DropdownMenuItem>;
    $[18] = currentRelationship;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  let t17;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <DropdownMenuSeparator />;
    $[20] = t17;
  } else {
    t17 = $[20];
  }
  let t18;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <LogOut className="w-4 h-4 mr-2" />;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== handleLogout) {
    t19 = <DropdownMenuItem onSelect={handleLogout} className="text-red-600 focus:text-red-600">{t18}Log Out</DropdownMenuItem>;
    $[22] = handleLogout;
    $[23] = t19;
  } else {
    t19 = $[23];
  }
  let t20;
  if ($[24] !== t16 || $[25] !== t19 || $[26] !== t3 || $[27] !== t8) {
    t20 = <DropdownMenuContent align="end" className={t3} sideOffset={5}>{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t19}</DropdownMenuContent>;
    $[24] = t16;
    $[25] = t19;
    $[26] = t3;
    $[27] = t8;
    $[28] = t20;
  } else {
    t20 = $[28];
  }
  let t21;
  if ($[29] !== t2 || $[30] !== t20) {
    t21 = <DropdownMenu>{t2}{t20}</DropdownMenu>;
    $[29] = t2;
    $[30] = t20;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  return t21;
}